import React, { useState } from 'react';
import './Catalog.css';
import blendImage from '../../assets/hamblend.webp';
import hamImage from '../../assets/ham.webp';
import fileEmpanadoImage from '../../assets/fileEmpanado.webp';
import tirasFrangoImage from '../../assets/tirasFrango.webp';
import hamEmpanadoImage from '../../assets/HamEmpanado.webp';

const Catalog = () => {
  const [imageErrors, setImageErrors] = useState({});

  // Debug: verificar se as imagens foram importadas
  console.log('Imagens importadas:', {
    blendImage,
    hamImage,
    fileEmpanadoImage,
    tirasFrangoImage,
    hamEmpanadoImage
  });

  const products = [
    {
      id: 1,
      name: 'Blend de Smash',
      description: 'Smash burger premium, fininho e suculento. Disponível em diversas gramagens e quantidades por caixa.',
      image: blendImage,
      specs: 'Consulte disponibilidade e variações'
    },
    {
      id: 2,
      name: 'Blend de Hambúrguer',
      description: 'Hambúrguer artesanal premium, macio e saboroso. Disponível em diversas gramagens e quantidades por caixa.',
      image: hamImage,
      specs: 'Consulte disponibilidade e variações'
    },
    {
      id: 3,
      name: 'Filé de Frango Empanado',
      description: 'Filé de frango empanado, crocante por fora e macio por dentro.',
      image: fileEmpanadoImage,
      specs: 'Consulte disponibilidade e variações'
    },
    {
      id: 4,
      name: 'Tiras de Frango Empanado',
      description: 'Tiras de frango empanado, crocantes e saborosas.',
      image: tirasFrangoImage,
      specs: 'Consulte disponibilidade e variações'
    },
    {
      id: 5,
      name: 'Hambúrguer de Frango Empanado',
      description: 'Hambúrguer de frango empanado, crocante e suculento.',
      image: hamEmpanadoImage,
      specs: 'Consulte disponibilidade e variações'
    }
  ];

  return (
    <section id="catalogo" className="catalog">
      <div className="catalog-container">
        <div className="catalog-header">
          <h2 className="catalog-title">Nossos Produtos</h2>
          <p className="catalog-subtitle">
            Fornecemos hambúrgueres premium e frango empanado para as melhores redes de fast food
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img 
                  src={imageErrors[product.id] ? 'https://via.placeholder.com/400x250/ff6b35/ffffff?text=' + encodeURIComponent(product.name) : product.image} 
                  alt={product.name}
                  onError={() => setImageErrors(prev => ({ ...prev, [product.id]: true }))}
                />
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                <div className="product-specs">
                  <span className="specs-text">{product.specs}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Catalog;